import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M12.3290765,14 L13.8601159,13.9678373 L9.07307556,2 L7.75487762,2 L3,13.9678373 L4.51212014,13.9678373 L5.50159631,11.4856332 L11.3268298,11.4856332 L12.3290765,14 Z M6.06728154,10.0666903 L8.41421308,4.17855031 L10.7611446,10.0666903 L6.06728154,10.0666903 Z"
        fill-rule="nonzero"
      />
    </svg>
  )
}
const FontColorIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontColorIcon
